export function buildCreatorsArray(creatorsListData){
    //the array thats passed in here will be a list of all the creators data for each comic book
    //if they are a writer, we pass them into the writersArray[] and so on
    //by setting it up like this, each arrays [0] will be the job title. then following entries will be names
    var creatorsArray = [];        
    var writersArray = [["Writers"],[] ];
    var inkersArray = [["Inkers"],[] ];
    var pencillersArray = [["Pencillers"],[] ];
    var coloristsArray = [["Colorists"],[] ];
    var letterersArray = [["Letterers"],[] ];
    var editorsArray = [["Editors"],[] ];
    var paintersArray = [["Painters"],[] ];

    creatorsListData.forEach(function(item,index){
        //divide all the creators into separate arrays with [0] being their title.
        //then push all those arrays into creatorsArray[]
        
        if(item.role === "writer"){
            writersArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "penciller" || item.role === "penciller (cover)"){
            pencillersArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "editor"){
            editorsArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "letterer"){
            letterersArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "colorist"){
            coloristsArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "painter" || item.role === "painter (cover)"){
            paintersArray[1].push(" " + item.name + ",");
        }
        else if(item.role === "inker"){
            inkersArray[1].push(" " + item.name + ",");
        }
    });
    

    





    //only include each job titles array into ceatorsArray[] if there's actually someone listed
    //can probably clean this up but fuck it
    //this will take each array of creators, find the last guy and take off the trailing comma 
    if(typeof writersArray[1][0] != 'undefined'){
        var lastPerson = writersArray[1].length - 1;
        var lastPersonNoComma = writersArray[1][lastPerson].slice(0, -1);
        writersArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(writersArray);
    }
    if(typeof pencillersArray[1][0] != 'undefined'){
        var lastPerson = pencillersArray[1].length - 1;
        var lastPersonNoComma = pencillersArray[1][lastPerson].slice(0, -1);
        pencillersArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(pencillersArray);
    }
    if(typeof editorsArray[1][0] != 'undefined'){
        var lastPerson = editorsArray[1].length - 1;
        var lastPersonNoComma = editorsArray[1][lastPerson].slice(0, -1);
        editorsArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(editorsArray);
    }
    if(typeof letterersArray[1][0] != 'undefined'){
        var lastPerson = letterersArray[1].length - 1;
        var lastPersonNoComma = letterersArray[1][lastPerson].slice(0, -1);
        letterersArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(letterersArray);
    }
    if(typeof coloristsArray[1][0] != 'undefined'){
        var lastPerson = coloristsArray[1].length - 1;
        var lastPersonNoComma = coloristsArray[1][lastPerson].slice(0, -1);
        coloristsArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(coloristsArray);
    }
    if(typeof paintersArray[1][0] != 'undefined'){
        var lastPerson = paintersArray[1].length - 1;
        var lastPersonNoComma = paintersArray[1][lastPerson].slice(0, -1);
        paintersArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(paintersArray);
    }
    if(typeof inkersArray[1][0] != 'undefined'){
        var lastPerson = inkersArray[1].length - 1;
        var lastPersonNoComma = inkersArray[1][lastPerson].slice(0, -1);
        inkersArray[1][lastPerson] = lastPersonNoComma;
        creatorsArray.push(inkersArray);
    }

    return creatorsArray;
}


// WEBPACK FOOTER //
// ./src/components/includes/buildCreatorsArray.js